import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="categories"
export default class extends Controller {
  connect() {
  }

  /*
   * Submits the business category create/update form via AJAX so the modal doesn't need
   * a full page reload. Used for both new category and edit category forms.
   *
   * We use FormData to serialize the form because the category form may include file uploads
   * (logo/images) in the future, and FormData handles multipart encoding automatically.
   * contentType: false and processData: false are required when sending FormData via jQuery
   * AJAX — without them, jQuery tries to serialize the FormData as a URL-encoded string,
   * which breaks multipart form submissions.
   * On success, we close the modal by clicking the close button programmatically, then
   * reload the business_categories_frame Turbo Frame so the category list updates without
   * a full page refresh.
   */
  save(e) {
    e.preventDefault()
    var item = e.currentTarget
    var data = new FormData(item);

    $.ajax({
      type: "POST",
      url: item.action,
      contentType: false,
      processData: false,
      data: data,
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {

        if(data.status == 200) {
          document.getElementById('close-modal-btn').click()
          document.getElementById('business_categories_frame').reload()
        } else {
          alert("Error saving category. Please try again.")
        }
      }
    })
  }
}
